import styled from 'styled-components';

const TextModal = styled.p`
  font-family: Roboto;
  text-align: left;
  color: #444b62;
  line-height: 21px;
  font-size: 16px;
  padding-left: 12px;
  padding-right: 12px;
  letter-spacing: 0px;
  margin: 18px 0px 24px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    line-height: 20px;
  }
`;

export default TextModal;
